import "./admincategory.css";

import React, { useCallback, useEffect, useState } from "react";
import {
  createSubCategory,
  deleteAdminSub_Category,
  getAllCategorySubcategory,
  updateSubCategory,
} from "../../apis";

import SelectField from "../../components/Select/Select";
import { TablePagination } from "@mui/material";
import actions from "../../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";

// Import updateSubCategory API

const AdminCategory = ({
  stopLoadingRequest,
  startLoadingRequest,
}) => {
  const [categories, setCategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [stylePreference, setStylePreference] = useState("");
  const [category, setcategory] = useState({ value: "", label: "" });
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedGender, setSelectedGender] = useState("Men"); // Default

  const mensSubcategories = [
    {
      "value": "67b59df0be7014af503af795",
      "label": "cargos",
      "gender": "Men"
    },
    {
      "value": "67b59de6be7014af503af789",
      "label": "casual trousers",
      "gender": "Men"
    },
    {
      "value": "67b59dd8be7014af503af77d",
      "label": "linen pants",
      "gender": "Men"
    },
    {
      "value": "67b59dcdbe7014af503af771",
      "label": "shorts",
      "gender": "Men"
    },
    {
      "value": "67b59dc4be7014af503af765",
      "label": "jeans",
      "gender": "Men"
    },
    {
      "value": "67b59dbbbe7014af503af759",
      "label": "formal trousers",
      "gender": "Men"
    },
    {
      "value": "67b59c2dbe7014af503af6b9",
      "label": "sweaters",
      "gender": "Men"
    },
    {
      "value": "67b59c19be7014af503af6ad",
      "label": "sweatshirts",
      "gender": "Men"
    },
    {
      "value": "67b59c0ebe7014af503af6a1",
      "label": "polo-neck",
      "gender": "Men"
    },
    {
      "value": "67b59c04be7014af503af695",
      "label": "formal shirts",
      "gender": "Men"
    },
    {
      "value": "67b59bfcbe7014af503af689",
      "label": "t-shirts",
      "gender": "Men"
    },
    {
      "value": "67b59bdebe7014af503af67d",
      "label": "casual button-down shirts",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf3e",
      "label": "sherwani",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf3c",
      "label": "nehru jacket",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf3a",
      "label": "dhoti",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf38",
      "label": "stole / shawl",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf36",
      "label": "salwar / pyjama",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf34",
      "label": "churidar",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf32",
      "label": "kurta / kurti",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf2e",
      "label": "summer coat",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf2c",
      "label": "summer jackets",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf2a",
      "label": "long coat",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf28",
      "label": "short coat",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf26",
      "label": "long jackets",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf24",
      "label": "short jackets",
      "gender": "Men"
    },
    {
      "value": "664faf656d6d3254381fbf22",
      "label": "blazers",
      "gender": "Men"
    }
  ]

  const womenSubcategories = [
    {
      "value": "67b5afacbe7014af503b0682",
      "label": "sweatshirts",
      "gender": "Women"
    },
    {
      "value": "67b5afa1be7014af503b0676",
      "label": "sweaters",
      "gender": "Women"
    },

    {
      "value": "664faf626d6d3254381fbece",
      "label": "sarees",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbecc",
      "label": "shawl",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeca",
      "label": "stole / dupatta",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbec8",
      "label": "salwar / palazzo",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbec6",
      "label": "skirts",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbec4",
      "label": "leggings / churidar",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbec2",
      "label": "kurta / kurti",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbebe",
      "label": "summer coat",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbebc",
      "label": "summer jackets",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeba",
      "label": "long coat",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeb8",
      "label": "short coat",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeb6",
      "label": "long jackets",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeb4",
      "label": "short jackets",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeb2",
      "label": "blazers",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeae",
      "label": "jumpsuit",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeac",
      "label": "playsuit",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbeaa",
      "label": "maxi dress",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbea8",
      "label": "midi dress",
      "gender": "Women"
    },
    {
      "value": "664faf626d6d3254381fbea6",
      "label": "mini dress",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbea2",
      "label": "joggers",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbea0",
      "label": "cargos",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe9e",
      "label": "culottes",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe9c",
      "label": "leggings / tights",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe9a",
      "label": "skirts",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe98",
      "label": "shorts",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe96",
      "label": "jeans",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe94",
      "label": "trousers",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe8c",
      "label": "special tops",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe8a",
      "label": "tunics",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe88",
      "label": "crop tops",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe86",
      "label": "bodysuits",
      "gender": "Women"
    },
    {
      "value": "664faf616d6d3254381fbe84",
      "label": "t-shirts",
      "gender": "Women"
    },
    {
      "value": "664faf606d6d3254381fbe80",
      "label": "button-down",
      "gender": "Women"
    },
    {
      "value": "664faf636d6d3254381fbed0",
      "label": "blouses",
      "gender": "Women"
    }
  ]


  // Fetch subcategories with search
  const fetch = useCallback(
    async (pageNum, rowsPerPageNum, searchValue = "") => {
      try {
        startLoadingRequest();
        const apiResponse = await getAllCategorySubcategory(
          "subcategory",
          pageNum + 1,
          rowsPerPageNum,
          {
            subcategoryText: searchValue,
          }
        );
        const AllSubCategories = await getAllCategorySubcategory(
          "subcategory",
          1,
          1000
        );

        if (apiResponse?.data?.data) {
          setCategories(apiResponse?.data?.data?.subcategories);
          setAllSubCategories(AllSubCategories?.data?.data?.subcategories);
          setTotalUsers(apiResponse?.data?.data?.totalUsers || 0);
        }

        const categoriesResponse = await getAllCategorySubcategory(
          "category",
          1,
          100
        );
        setAllCategories(
          categoriesResponse?.data?.data?.categories.map((el) => ({
            value: el._id,
            label: el.name,
            gender: el.stylePreference,
          }))
        );
        stopLoadingRequest();
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        stopLoadingRequest();
      }
    },
    [startLoadingRequest, stopLoadingRequest]
  );

  // Combined effect for search and pagination
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetch(page, rowsPerPage, searchTerm);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, page, rowsPerPage, fetch]);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const handleSubmitSubCategory = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!categoryName.trim()) {
      newErrors.categoryName = "Subcategory name is required.";
    }

    if (!category || !category.value) {
      newErrors.category = "Category selection is required.";
    }

    if (selectedSubcategories.length === 0) {
      newErrors.selectedSubcategories = "Select at least one valid pair.";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(
        newErrors.categoryName ||
        newErrors.category ||
        newErrors.selectedSubcategories
      );
      return;
    }

    try {
      setError("");

      const formData = {
        name: categoryName,
        stylePreference,
        validCombinations: selectedSubcategories.map((item) => item),
      };

      if (selectedSubCategory) {
        formData.subcategoryId = selectedSubCategory;
        const response = await updateSubCategory(formData, category.value);

        if (response.status === 200) {
          toast.success("Subcategory updated successfully!");
        }
      } else {
        const response = await createSubCategory(formData, category.value);
        if (response.status === 200) {
          toast.success("Subcategory created successfully!");
        }
      }

      setIsModalOpen(false);
      setCategoryName("");
      setStylePreference("");
      setcategory({ value: "", label: "" });
      setSelectedSubCategory(null);
      fetch();
    } catch (error) {
      console.error("Error creating/updating subcategory:", error);
      toast.error("Failed to process the request.");
    }
  };

  // Open modal for adding or editing subcategory
  const handleAddCategory = (subcategory = null) => {
    if (subcategory) {
      setSelectedSubCategory(subcategory._id); // If editing, set the selected subcategory
      setCategoryName(subcategory.name);
      setSelectedSubcategories(subcategory?.validCombinations)
      // setStylePreference(subcategory.stylePreference);
      setcategory({ label: subcategory.categoryId.name, value: subcategory.categoryId._id })
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCategoryName("");
    setStylePreference("");
    setSelectedSubCategory(null);
    setError("");
  };


  const handleDelete = async (data) => {
    if (data) {
      // alert(data?._id)
      const response = await deleteAdminSub_Category({
        subcategoryId: data?._id,
      });
      if (response.status === 200) {
        toast.success("Subcategory Deleted successfully!");
      }
      fetch(page, rowsPerPage, searchTerm);
    }
  };

  const selectDropdownChangeHandler = useCallback((name, value) => {
    setcategory(value);
  }, []);

  const subcategoryOptions = selectedGender === "Women" ? womenSubcategories : mensSubcategories;



  const handleSelectChange = (event) => {
    const { value, checked } = event.target;

    setSelectedSubcategories((prevSelected) =>
      checked
        ? [...prevSelected, value]
        : prevSelected.filter((id) => id !== value)
    );
  };

  // Filter categories based on selected gender

  const filteredCategories = allCategories.filter(
    cat => cat.gender === selectedGender
  );



  return (
    <div className="">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <button
          className="add-category-button-new"
          onClick={() => handleAddCategory(null)}
        >
          Add Subcategory
        </button>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search subcategories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              width: "300px",
            }}
          />
        </div>
      </div>

      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Subcategory Name</th>
            <th>Category</th>
            {/* <th>Gender</th> */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories?.map((category, index) => (
            <tr key={category._id}>
              <td>{page * rowsPerPage + index + 1}</td>
              <td>{category?.name}</td>
              <td>{category?.category?.name}</td>
              {/* <td>{category?.category?.stylePreference}</td> */}
              <td>
                <div className="table-actions">
                  <button
                    onClick={() => handleAddCategory(category)}
                    className={`edit-button-new ${category?.statusType === "Admin" ? 'disabled' : ''}`}
                    disabled={category?.statusType === "Admin"}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      handleDelete(category);
                    }}
                    className={`delete-button-new ${category?.statusType === "Admin" ? 'disabled' : ''}`}
                    disabled={category?.statusType === "Admin"}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalUsers}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {isModalOpen && (
        <div
          style={{
            zIndex: "10000",
            position: "fixed", // Changed to fixed
            top: 0, // Covering the entire screen
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent background
            backdropFilter: "blur(10px)", // Blur effect
          }}
        >
          <div className="modal-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ margin: 0 }}>
                {selectedSubCategory
                  ? "Edit Subcategory"
                  : "Add New Subcategory"}
              </h2>
              <span className="close" onClick={closeModal}>
                &times;
              </span>
            </div>
            <form onSubmit={handleSubmitSubCategory}>
              <div className="form-group">
                <label htmlFor="categoryName">Subcategory Name</label>
                <input
                  type="text"
                  id="categoryName"
                  name="categoryName"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
                {error && (
                  <small style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </small>
                )}
              </div>
              <div className="form-group" >
                <label htmlFor="gender">Gender</label>
                <select
                  id="gender"
                  name="gender"
                  value={selectedGender}
                  onChange={e => {
                    setSelectedGender(e.target.value);
                    setcategory({ value: "", label: "" }); // Reset category when gender changes
                  }}
                  className="form-control"
                  style={{border:"1px solid #ddd"}}
                  required
                >
                  <option value="">Select Gender</option>
                  <option value="Men">Men</option>
                  <option value="Women">Women</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="stylePreference">Select Category</label>
                <SelectField
                  name="role"
                  onChange={selectDropdownChangeHandler}
                  value={category}
                  isMulti={false}
                  options={filteredCategories}
                  isDisabled={!selectedGender}
                  placeholder={selectedGender ? "Select Category" : "Please select gender first"}
                />
              </div>
              <div className="form-group">
                <label htmlFor="stylePreference">Select Possible Pairs of {categoryName}</label>
                <input
                  type="text"
                  placeholder="Search subcategories..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control mb-2"
                />
                {error && (<small style={{ color: "red", fontSize: "12px" }}>{error}</small>)}
                <hr />
                <i>{selectedSubcategories.length} combinations are selected</i>
                <hr />

                {subcategoryOptions.map((subcategory) => (
                  <div key={subcategory.value} style={{ display: 'flex', alignItems: 'center', gap: '10px',paddingTop:"-4px",paddingBottom:"4px" }}>
                    <input
                      type="checkbox"
                      id={subcategory.value}
                      value={subcategory.value}
                      checked={selectedSubcategories.includes(subcategory.value)}
                      onChange={handleSelectChange}
                      className="form-check-input"
                    />
                    <label htmlFor={subcategory.value}>
                      {subcategory.label}
                    </label>
                  </div>
                ))}
              </div>
              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="submit-button">
                  {selectedSubCategory ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      activateModal: actions.modal.activateModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AdminCategory);
